// removed by extract-text-webpack-plugin
module.exports = {"button":"DismissButton__button___1eg_M"};